/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const hover = () => {
  const topics = document.querySelectorAll(
    '.js-main-topics-links .js-to-hover-compact',
  );
  const getNodeindex = elm => [...elm.parentNode.children].indexOf(elm);
  const images = document.querySelectorAll('.js-topics-hover-target img');
  topics.forEach(topic => {
    topic.addEventListener(
      'mouseover',
      event => {
        if (topic !== event.target) return;
        images.forEach(image => {
          image.classList.remove('is-active');
        });
        topics.forEach(topic2 => {
          topic2.classList.remove('is-active');
        });
        images[getNodeindex(event.target)].classList.add('is-active');
        topics[getNodeindex(event.target)].classList.add('is-active');
      },
      true,
    );
  });
};

export default hover;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/hover.js